/**
 * This server is a temporary bridge between socket service and $rootScope, since we have no $rootScope in Angular,
 * it is dead simple so please do not modify it only if necessary
 */
class SocketEventTransformerService {
    constructor($rootScope, socketService, subscriptionService, logService) {
        this.logger = new LogServiceWrapper(logService, 'socketEventTransformerService');
        this.$rootScope = $rootScope;
        this.socketService = socketService;
        this.subscriptionService = subscriptionService;

        this.rootSubscription = this.subscriptionService.createSubscription();

        $rootScope.$on('$destroy', this.onScopeDestroyed.bind(this));
    }

    /**
     * node-connected: dispatched on first socket connection to the server only
     * node-reconnected: dispatched on every subsequent connection to the server except first
     */
    init() {
        this.rootSubscription.add(
            this.socketService.nodeConnected$.subscribe(next => {
                switch (next) {
                    case 'connected':
                        this.$rootScope.$broadcast('node-connected');
                        break;
                    case 'reconnected':
                        this.$rootScope.$broadcast('node-reconnected');
                        break;
                    case 'disconnected':
                        this.$rootScope.$broadcast('node-disconnected');
                        break;
                    default:
                        this.logger.warn('Unsupported connection state was detected: ', next);
                        return;
                }
            })
        );
        this.rootSubscription.add(
            this.socketService
                .onMessage$('client-event')
                .subscribe(socketEvent => this.$rootScope.$broadcast(socketEvent.message, socketEvent.data))
        );
    }

    onScopeDestroyed() {
        this.subscriptionService.endSubscription(this.rootSubscription);
    }
}

firebird.factory('socketEventTransformerService', [
    '$rootScope',
    'socketService',
    'subscriptionService',
    'logService',
    (...deps) => new SocketEventTransformerService(...deps)
]);
